import { FormBase } from "../../util/form-base-form";

export class ScrollHideForm extends FormBase {
    public getNavbar(): HTMLElement | null {
        return this.queryElement(document.body, ".navbar", HTMLElement);
    }

    public getFooter(): HTMLElement | null {
        return null; // footer is now static (in normal flow); scroll-hide not applicable
    }
}
